(() => {
  const diagramPoint = document.querySelectorAll('.diagram__point');
  const diagramContent = document.querySelectorAll('.diagram_content');
  const diagramMenu = document.getElementById('diagram_points');
  const diagramButton = document.getElementById('diagram_button');
  const openerPoints = document.getElementById('opener_points');
  const labelClass = "diagram__point_label";
  let openedContentId = null;

  const getContent = (id) => document.querySelector('[data-content-id="' + id + '"]');
  const getPoint = (id) => document.querySelector('[data-point-id="' + id + '"]');
  const isDesktop = () => window.innerWidth >= 1200;
  
  const resetDiagram = () => {
    diagramContent.forEach(content => {
      content.classList.remove('opened');
    });

    diagramPoint.forEach(point => {
      point.classList.remove('active');
      point.setAttribute('tabindex', 0);
    });

    diagramMenu.classList.remove('hover', 'selected');

    document.getElementById("opener_points").checked = false;
  };

  if (diagramPoint.length > 0 && diagramContent.length > 0 && diagramMenu && diagramButton) {
    diagramContent.forEach(content => {
      content.addEventListener('click', event => {
        if (isDesktop()) return;
        
        let current = event.currentTarget;
        let contentId = current.dataset.contentId;

        if (openedContentId !== contentId && openedContentId) {
          getContent(openedContentId).classList.remove('opened');
        }

        current.classList.toggle('opened');
        openedContentId = contentId;
      });
    }); // Mobile/Tablet Only - Diagram Accordion
    
    diagramPoint.forEach(point => {
      point.addEventListener('mouseover', event => {
        if(event.target.classList.contains(labelClass)) return;
        let contentId = point.dataset.pointId;
        let content = getContent(contentId);
        diagramMenu.classList.add("hovered");

        if (content !== null) content.classList.add('visible');

        if (openedContentId !== contentId && openedContentId) {
          const openedContent = getContent(openedContentId);
          const openedPoint = getPoint(openedContentId);
          openedContent.classList.remove('opened');
          openedPoint.classList.remove('active');
          diagramMenu.classList.remove('selected');

          diagramPoint.forEach(p => {
            if (p !== openedPoint) {
              p.setAttribute('tabindex', -1);
            }
          });
        }
      });

      point.addEventListener('mouseout', () => {
        diagramMenu.classList.remove("hovered");

        diagramContent.forEach(elem => {
          elem.classList.remove('visible');
        });
      });

      point.addEventListener('keydown', function (event) {
        if (event.code === 'Space' || event.code === 'Enter') {
          event.preventDefault();
          point.click();
        }
      });

      point.addEventListener('click', event => {
        let current = event.currentTarget;
        let contentId = point.dataset.pointId;
        let content = getContent(contentId);

        if(content !== null) {
          current.classList.toggle("active");
          diagramMenu.classList.toggle('selected');
          content.classList.toggle('opened');
          openedContentId = contentId;
          
          if(current.classList.contains("active") ) {             
            current.setAttribute('aria-expanded', 'true');
            diagramPoint.forEach(p => {
              if(p !== point) {
                p.setAttribute('tabindex', -1);
              }
            });
          } else {
            current.setAttribute('aria-expanded', 'false');
            diagramPoint.forEach(p => {
              p.setAttribute('tabindex', 0);
            });
          }
        }
      });
    }); // Desktop Only - Diagram

    diagramButton.addEventListener('click', () => {
      if(openerPoints.checked && openedContentId) {
        let content = getContent(openedContentId);

        if(content !== null) {
          content.classList.remove('opened');
          document.querySelector('[data-point-id="'+openedContentId+'"]').classList.remove("active");
          diagramMenu.classList.remove('selected');          
        }
        openedContentId = null;
      }

      if (diagramButton.getAttribute('aria-expanded') === "true") {
        diagramPoint.forEach(p => {
          p.setAttribute('tabindex', -1);
          p.classList.remove('opened');
        });
      } else {
        diagramPoint.forEach(p => {
          p.setAttribute('tabindex', 0);
          p.classList.remove('opened')
        });
      }
    });

    diagramButton.addEventListener('keydown', function (event) {
      if (event.code === 'Enter') {        
        diagramButton.click();
      }
    });
    
    let resetTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resetTimeout);
      resetTimeout = setTimeout(resetDiagram, 100);
    });
  }
})();
